import { EditOutlined } from "@ant-design/icons";
import { Card, Typography } from "antd";
import { IObject } from "@/entities/api/object";
import { generateConstructionTypeName } from "@entities/object";
import { useRouter } from "@shared/lib/hooks";
import { routes } from "@shared/lib/react-router";
import "./object-card.scss";

const { Title, Text } = Typography;

interface IObjectCard {
  handleIsForm: (event: any, status: boolean, objectId?: string) => void;
  projectId: string;
  object: IObject;
}
export const ObjectCard = ({
  handleIsForm,
  projectId,
  object,
}: IObjectCard) => {
  const { navigate } = useRouter();
  const goToObjectPage = () => {
    navigate(routes.objects.object(projectId, object.buildingObjectId));
  };
  return (
    <Card className="custom-card" onClick={goToObjectPage} bordered={false}>
      <div className="card-content">
        <Title level={5} className="card-title">
          {object.shortName || ""}
        </Title>
        <Text type="secondary" className="card-address">
          {object.address.addressString || ""}
        </Text>
        {/* <ProjectDetails tasks={99} files={99} folders={99} /> */}
        <div className="icon-container icon-container--hidden">
          <EditOutlined
            className="icon-custom edit-icon"
            onClick={(event) =>
              handleIsForm(event, true, object.buildingObjectId)
            }
          />
          {/* <DeleteOutlined className="icon-custom delete-icon" onClick={showModal} /> */}
        </div>

        <Text type="secondary" className="card-tag">
          {generateConstructionTypeName(
            String(object.address.addressType) || "",
          )}
        </Text>
      </div>
    </Card>
  );
};
